export default __webpack_public_path__ + "static/media/home_background.c8b6851d.mp3";